import { css } from '@emotion/react';
import { breakpoints } from '../primitives/tokens';

// Note: This filename is cased incorrectly, the fix touches 24 files of mostly old JS, out of scope for now

const RichTextEditorStyles = css({
    a: {
        color: '#ff7200',
        fontWeight: 600,
    },
    p: {
        marginBottom: '24px',
        '&:last-child': {
            marginBottom: 0,
        },
    },
    h1: {
        fontSize: '54px',
        lineHeight: 1.1,
        marginBottom: '28px',
        [breakpoints.mb]: {
            fontSize: '48px',
        },
    },
    h2: {
        fontSize: '36px',
        lineHeight: 1.33,
        color: '#2b3b48',
        marginBottom: '15px',
        marginTop: '16px',
        '&:first-of-type': {
            marginTop: 0,
        },
        [breakpoints.mb]: {
            lineHeight: 1,
        },
    },
    h3: {
        fontSize: '18px',
        letterSpacing: '2.57px',
        lineHeight: '22px',
        color: '#ff7400',
        marginBottom: '7px',
        marginTop: '16px',
        fontWeight: 400,
        '&:first-of-type': {
            marginTop: 0,
        },
        [breakpoints.mb]: {
            fontWeight: 600,
        },
    },
    h4: {
        fontSize: '24px',
        fontWeight: 600,
        lineHeight: '33px',
        color: '#2b3a49',
        letterSpacing: '0.34px',
    },
    ul: {
        marginBottom: '16px',
    },
    li: {
        listStylePosition: 'outside',
        listStyleType: 'disc',
        marginLeft: '24px',
        marginBottom: '8px',
    },
    hr: {
        marginBottom: '24px',
    },
    blockquote: {
        fontSize: '36px',
        lineHeight: '2.5rem',
        color: 'rgb(255, 102, 0)',
        marginTop: '80px',
        marginBottom: '80px',
        [breakpoints.tb]: {
            fontSize: '18px',
            lineHeight: '28px',
            marginTop: '40px',
            marginBottom: '40px',
        },
    },
    table: {
        border: '1px solid #dddddd',
        borderCollapse: 'collapse',
    },
    th: {
        border: '1px solid #dddddd',
    },
    td: {
        border: '1px solid #dddddd',
        padding: '8px',
    },
});

export default RichTextEditorStyles;
